import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'
import tabsview from './tabsview'
import storage from '@/function/storage.js'
import VueCookies from 'vue-cookies';

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		tabsview
	},
	state: {
		token: storage.getItem('token') || null,
		title: '',
		//menuList: JSON.parse(localStorage.getItem('menuList')) || [],
		dashboardUrl: localStorage.getItem('DASHBOARD') || 'none.vue',
		storeName: localStorage.getItem('storeName') || '',
		storeHost: localStorage.getItem('storeHost') || '',
		storeLogo: localStorage.getItem('storeLogo') || '',
		isEmployee: localStorage.getItem('isEmployee') || '',
		userName: localStorage.getItem('userName') || '',
		realName: localStorage.getItem('realName') || '',
		tenantId: localStorage.getItem('tenantId') || '',
		userId: localStorage.getItem('userId') || '',
		avatar: localStorage.getItem('avatar') || '',
		nickName: localStorage.getItem('nickName') || '',
		isVIP: localStorage.getItem('ISVIP') || false,
	},
	mutations: {
		[types.LOGIN]: (state, data) => {
			var dateTime = new Date();
			var expiresTime = dateTime.setHours(dateTime.getHours() + 23);
			state.token = data.accessToken;
			state.userName = data.userName;

			storage.setItem({
				name: 'token',
				value: data.accessToken,
				expires: expiresTime,
			})

			var userData = {
				accessToken: data.accessToken,
				userId: data.userId,
				userName: data.userName
			}
			localStorage.setItem('userData', JSON.stringify(userData))
			localStorage.setItem('realName', data.realName);
			localStorage.setItem('tenantId', data.tenantId);
			localStorage.setItem('userName', data.userName);
			localStorage.setItem('avatar', data.avatar || '');
			localStorage.setItem('nickName', data.nickName || '');
			localStorage.setItem('userId', data.userId);
			localStorage.setItem('ISVIP', data.isVIP);

			state.isVIP = data.isVIP;

			state.avatar = data.avatar;
			state.nickName = data.nickName;
			state.realName = data.realName || '';

			var hoststr = "";
			let firstDotIndex = window.location.hostname.indexOf('.')
			if (firstDotIndex == -1) hoststr = "localhost";
			else hoststr = window.location.hostname.substr(firstDotIndex + 1);

			VueCookies.set("userData", userData, 60 * 60 * 24, null, hoststr);


			var tids = [1, 5, 6, 9, 10, 11, 12, 92, 93, 94, 110, 125,84];
			tids = tids.concat([15,44, 49, 56, 58, 61, 74, 98, 100, 116, 112, 126]) // 学校
			var tenantId = null;
			try {
				tenantId = parseInt(data.tenantId);
			} catch (error) {
				tenantId = null
			}
			localStorage.setItem('schoolVersion', (tids.indexOf(tenantId) < 0));
		},
		[types.SETTOKEN]: (state, data) => {
			state.token = data;
		},
		["ISVIP"]: (state, data) => {
			localStorage.setItem('ISVIP', data);

			state.isVIP = data;
		},
		[types.LOGOUT]: (state) => {
			localStorage.removeItem('token');
			localStorage.removeItem('DASHBOARD');
			localStorage.removeItem('storeName');
			localStorage.removeItem('isEmployee');
			localStorage.removeItem('menuList');
			localStorage.removeItem('userName');
			localStorage.removeItem('realName');
			localStorage.removeItem('tenantId');
			localStorage.removeItem('avatar');
			localStorage.removeItem('nickName');
			localStorage.removeItem('userId');

			VueCookies.remove("userData");

			state.token = null
			state.dashboardUrl = ''
			state.storeName = '';
			state.userName = '';
			state.avatar = '';
			state.nickName = '';
			state.realName = '';
			state.isEmployee = false;
			state.menuList = [];
		},
		[types.TITLE]: (state, data) => {
			state.title = data;
		},
		[types.MENU]: (state, data) => {
			localStorage.setItem('menuList', JSON.stringify(data))
			state.menuList = data;
		},
		[types.STORE]: (state, data) => {
			if (data) {
				state.storeName = data.tenantName;
				state.storeHost = data.hostUrl;
				state.storeLogo = data.logo;
				localStorage.setItem('storeName', data.tenantName)
				localStorage.setItem('storeHost', data.hostUrl)
				localStorage.setItem('storeLogo', data.logo)
			} else {
				localStorage.setItem('storeName', '')
				localStorage.setItem('storeHost', '')
				localStorage.setItem('storeLogo', '')
			}
		},
		['DASHBOARD']: (state, data) => {
			state.dashboardUrl = data;
			localStorage.setItem('DASHBOARD', data)
		},
		['Employee']: (state, data) => {
			state.isEmployee = data.toString();
			localStorage.isEmployee = data.toString();
		},
	},
	getters: {
		token: state => {
			return storage.getItem('token');
		},
		realName: state => {
			return state.nickName || state.realName;
		},
		nickName: state => {
			if (state.realName) {
				return state.realName;
			}
			if (state.nickName) {
				return state.nickName;
			}
			return state.userName;
		},
		storeLogo: state => {
			return storage.getItem('storeLogo');
		},
		storeName: state => {
			return storage.getItem('storeName');
		},
		tenantId: state => {
			return parseInt(localStorage.getItem('tenantId'));
		},
		isVIP: state => {
			return state.isVIP;
		},
		userId: state => {
			return parseInt(localStorage.getItem('userId'));
		},
		userIdStr: state => {
			var uid = localStorage.getItem('userId');
			if (uid != undefined && uid != NaN) return uid;
			return '';
		},
		isNMHost: state => {
			return window.location.hostname.indexOf('ningmengcode.com') >= 0 || window.location.hostname
				.indexOf('localhost') >= 0;
		},
		avatar: state => state.avatar || '',
		schoolVersion: state => {
			var tids = [1, 5, 6, 9, 10, 11, 12, 92, 93, 94, 110, 125,84];
			tids = tids.concat([15,44, 49, 56, 58, 61, 74, 98, 100, 112, 116, 126]) // 学校
			var tenantId = null;
			try {
				tenantId = parseInt(localStorage.getItem('tenantId'));
			} catch (error) {
				tenantId = null
			}
			localStorage.setItem('schoolVersion', (tids.indexOf(tenantId) < 0));
			return (tids.indexOf(tenantId) < 0);
		}
	}
})